// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;


const navConfig = [
  {
    title: 'Dashboard',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
  },
  {
    title: 'Lead Management',
    path: '/dashboard/lead',
    icon: icon('ic_lead'),
   },
   {
    title: 'Bankrate Leads',
    path: '/dashboard/bankrate-lead',
    icon: icon('ic_lead'),
   },
     {
    title: 'State Management',
    path: '/dashboard/states',
    icon: icon('ic_lead'),
   },
   {
    title: 'Branch Management',
    path: '/dashboard/branches',
    icon: icon('ic_lead'),
   },
   {
    title: 'Intake Form Management',
    path: '/dashboard/intake',
    icon: icon('ic_lead'),
   },
  //  {
  //   title: 'Contact Management',
  //    path: '/dashboard/contact',
  //    icon: icon('ic_contact'),
  //  },
  {
    title: 'Loan Officer Dashboard',
    path: '/dashboard/loanofficers',
    icon: icon('ic_contact'),
  },
   {
    title: 'Loan Management',
     path: '/dashboard/loan',
     icon: icon('ic_policy'),
   },
   {
    title: 'Blog Management',
     path: '/dashboard/blog',
     icon: icon('ic_policy'),
   },
   {
    title: 'SEO / Pages',
     path: '/dashboard/seo',
     icon: icon('ic_policy'),
   },

  // {
  //   title: 'Tasks',
  //   path: '/dashboard/task',
  //   icon: icon('ic_task'),
  // },
  // {
  //   title: 'Meetings',
  //   path: '/dashboard/meeting',
  //   icon: icon('ic_meeting'),
  // },
  // {
  //   title: 'Calls',
  //   path: '/dashboard/call',
  //   icon: icon('ic_call'),
  // },
  // {
  //   title: 'Emails',
  //   path: '/dashboard/email',
  //   icon: icon('ic_email'),
  // },
  // {
  //   title: 'Calendar',
  //   path: '/dashboard/calendar',
  //   icon: icon('ic_calendar'),
  // },
  // {
  //   title: 'Document Management',
  //   path: '/dashboard/document',
  //    icon: icon('ic_document'),
  // },
  // {
  //   title: 'Docusign Management',
  //   path: '/dashboard/docusign',
  //    icon: icon('ic_document'),
  // },
  // {
  //   title: 'Email Template',
  //   path: '/dashboard/emailtemplate',
  //   icon: icon('ic_emailTemplate'),
  // },
  {
    title: 'User Management',
    path: '/dashboard/user',
    icon: icon('ic_user'),
  },
  // {
  //   title: 'Landing Page',
  //   path: '/dashboard/landingpage',
  //   icon: icon('ic_user'),
  // },

  // {
  //   title: 'History',
  //   path: '/dashboard/history',
  //   icon: icon('ic_history'),
  // },

];

export default navConfig;
